import type { ProjectRepository } from '../repository/ProjectRepository';
import type { ProjectDonorsSumCommand, ProjectDonorsSumResponse } from '../entity/ProjectTypes';

export class SumProjectDonorsUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectDonorsSumCommand): Promise<ProjectDonorsSumResponse> {
    return this.repository.sumProjectDonors(command);
  }
}
